export const getSavedPayoutDetails = currentUser =>
  currentUser?.attributes?.profile?.privateData?.payoutDetails || null;

export const buildPayoutDetailsSnapshot = (values = {}) => {
  const bankAccount = values?.bankAccount || {};
  const accountNumber = bankAccount.number || values?.accountNumber || '';
  const last4 = accountNumber ? String(accountNumber).slice(-4) : '';

  return {
    name: values?.name || '',
    email: values?.email || '',
    type: values?.type || values?.accountType || 'individual',
    bankBrand: bankAccount.brand || values?.bankBrand || '',
    bankAccountName: bankAccount.name || values?.bankAccountName || '',
    bankAccountNumber: accountNumber || '',
    bankAccountLast4: last4,
    corporationName: values?.corporationName || '',
    tax_id: values?.tax_id || '',
    updatedAt: new Date().toISOString(),
  };
};

export const buildInvalidPayoutDetailsSnapshot = (
  currentUser,
  { recipientId, reason = 'OMISE_RECIPIENT_NOT_FOUND' } = {}
) => {
  const saved = getSavedPayoutDetails(currentUser) || {};

  return {
    ...saved,
    recipientId: null,
    recipientStatus: 'invalid',
    invalidRecipientId: recipientId || saved.recipientId || null,
    invalidReason: reason,
    invalidatedAt: new Date().toISOString(),
  };
};

export const buildOmiseInitialValues = ({ recipientData, savedPayoutDetails } = {}) => {
  const saved = savedPayoutDetails || {};
  const bankAccount = recipientData?.bank_account || {};
  const metadata = recipientData?.metadata || {};

  return {
    name: recipientData?.name || saved.name || '',
    email: recipientData?.email || saved.email || '',
    type: recipientData?.type || saved.type || 'individual',
    bankBrand: bankAccount.bank_code || saved.bankBrand || '',
    accountNumber: saved.bankAccountNumber || bankAccount.account_number || '',
    bankAccountName: bankAccount.name || saved.bankAccountName || '',
    corporationName: metadata.corporationName || saved.corporationName || '',
    tax_id: recipientData?.tax_id || saved.tax_id || '',
  };
};
